var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import { getCustomerInfo, updateCustomer } from "../utils/requests";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
/**
 * useCustomerInfo()
 * * This is a custom hook that fetches and updates information for the current customer.
 */
const useCustomerInfo = () => {
    const { datadogLog } = useLogging();
    const [customer, setCustomer] = useState();
    const [showSMSOption, setShowSMSOption] = useState(false);
    const [errors, setErrors] = useState();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        const onSuccess = (res) => {
            var _a, _b;
            if (!res.data.success) {
                setLoading(false);
                setErrors({ fatal: res.data.message });
                return;
            }
            setShowSMSOption(res.data.showSMSOption);
            const phoneNumberObject = {
                countryCode: (_a = res.data.customerInfo.phoneNumber) === null || _a === void 0 ? void 0 : _a.countryCode,
                number: (_b = res.data.customerInfo.phoneNumber) === null || _b === void 0 ? void 0 : _b.number,
            };
            setCustomer({
                firstName: res.data.customerInfo.FirstName,
                lastName: res.data.customerInfo.LastName,
                email: res.data.customerInfo.Email,
                phone: res.data.customerInfo.Phone,
                communicationPreferences: res.data.customerInfo.CommunicationPreferences,
                phoneNumber: phoneNumberObject,
                providerCustomerId: res.data.customerInfo.provider_customer_id,
                dayBankDays: res.data.customerInfo.DayBankDays,
            });
            setLoading(false);
        };
        const onError = (err) => {
            setLoading(false);
            setErrors({ fatal: "Something went wrong while loading Profile information." });
        };
        getCustomerInfo(onSuccess, onError);
    }, []);
    const handleCustomerUpdate = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading(true);
        try {
            let res = yield updateCustomer(data);
            if (!((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.success)) {
                setLoading(false);
                datadogLog("Failed to update customer information", LogLevel.ERROR, undefined, new Error(res.data.message));
                return { success: false, error: res.data.error, message: res.data.message };
            }
            setErrors(null);
            setLoading(false);
            return res.data;
        }
        catch (error) {
            setLoading(false);
            let message = "Something unexpected happened while updating your information.";
            if (error.response && error.response.data) {
                const errorResponse = error.response.data;
                if (errorResponse.Message) {
                    message = errorResponse.Message;
                }
                if (errorResponse.ModelErrors) {
                    const modelErrors = errorResponse.ModelErrors;
                    const updateCustomerErrors = {};
                    if (modelErrors.Password) {
                        updateCustomerErrors.newPasswordErrors = modelErrors.Password;
                    }
                    if (modelErrors.CurrentPassword) {
                        updateCustomerErrors.currentPasswordErrors = modelErrors.CurrentPassword;
                    }
                    if (modelErrors.Email) {
                        updateCustomerErrors.emailErrors = modelErrors.Email;
                    }
                    if (updateCustomerErrors) {
                        setErrors(updateCustomerErrors);
                    }
                }
                else if (errorResponse.Errors) {
                    message += ". " + error.response.Errors.join(". ");
                }
            }
            datadogLog("Failed to update customer information", LogLevel.ERROR, undefined, error);
            return { success: false, message };
        }
    });
    const removeErrors = () => {
        setErrors(null);
    };
    return {
        loading,
        errors,
        customer,
        showSMSOption,
        handleCustomerUpdate,
        removeErrors,
        providerCustomerId: customer === null || customer === void 0 ? void 0 : customer.providerCustomerId,
    };
};
export default useCustomerInfo;
